























import Vue from 'vue';
import { mapGetters } from 'vuex';
import { SAVE_STATE, LOAD_STATE } from '@/store/shared';
import eventBus from '@/helpers/event-bus';
import {
  FETCH_DUNNING_CAMPAIGN_BLUEPRINT,
  PUBLISH_DUNNING_CAMPAIGN_BLUEPRINT,
  SCHEDULE_SAVE_DUNNING_CAMPAIGN_BLUEPRINT,
  UPDATE_DUNNING_CAMPAIGN_BLUEPRINT,
} from '@/store/action-types';
import {
  SET_DUNNING_CAMPAIGN_EMAIL,
  SET_CURRENT_DUNNING_CAMPAIGN_BLUEPRINT_ID,
  SET_CURRENT_DUNNING_EMAIL_BLUEPRINT_ID,
  STORE_DUNNING_CAMPAIGN_BLUEPRINT_DATA,
} from '@/store/mutation-types';
import { ICampaignBlueprint, IEmailBlueprint, IState, IUser } from '@/store/types';
import CampaignSequence from '@/components/Dunning/CampaignSequence.vue';
import EmailEditor from '@/components/Dunning/EmailEditor.vue';
import CampaignEditorLoader from '@/components/UI/Loader/CampaignEditorLoader.vue';
import { generateEmailBlueprint } from '@/helpers/templates';

export default Vue.extend({
  name: 'CampaignEditor',
  components: {
    CampaignSequence,
    EmailEditor,
    CampaignEditorLoader,
  },
  data() {
    return {
      SAVE_STATE,
      LOAD_STATE,
      publishLoading: false,
      loadingCampaignBlueprint: true,
    };
  },
  async created() {
    const state = this.$store.state as IState;
    await this.$store.dispatch(FETCH_DUNNING_CAMPAIGN_BLUEPRINT, this.$route.params.id);
    // await this.$store.dispatch(SYNC_DUNNING);
    this.$store.commit(SET_CURRENT_DUNNING_CAMPAIGN_BLUEPRINT_ID, this.$route.params.id);
    if (this.hasEmails) {
      this.$store.commit(SET_CURRENT_DUNNING_EMAIL_BLUEPRINT_ID, this.currentCampaignEmailBlueprints[0].guid);
    }
    this.loadingCampaignBlueprint = false;
  },
  computed: {
    ...mapGetters([
      'campaignBlueprints',
      'currentCampaignBlueprint',
      'currentCampaignBlueprintId',
      'currentCampaignBlueprintLoadState',
      'currentDunningCampaignBlueprintSaveState',
      'currentEmailBlueprint',
      'currentCampaignEmailBlueprints',
      'currentCampaignEmailBlueprintMap',
      'userOrgSubscription',
      'isAdmin',
      'isLocal',
      'payingCustomer',
      'baseEmailBlueprint', // basic template to insert a new email into an empty campaign
    ]),
    hasEmails(): boolean {
      return this.currentCampaignEmailBlueprints && this.currentCampaignEmailBlueprints.length > 0;
    },
    allEmails(): IEmailBlueprint[] {
      if (!this.hasEmails) {
        return [];
      }
      return this.$store.getters.currentCampaignEmailBlueprints;
    },
    campaignBlueprintId(): string {
      return this.$route.params.id;
    },
    campaignBlueprint(): ICampaignBlueprint | undefined {
      if (!this.campaignBlueprintId) {
        return undefined;
      }
      return this.$store.state.campaignBlueprints[this.campaignBlueprintId];
    },
    user(): IUser {
      return this.$store.state.user;
    },
  },
  methods: {
    openChat(): void {
      eventBus.$emit('openChat');
    },
    scheduleSave() {
      this.$store.dispatch(SCHEDULE_SAVE_DUNNING_CAMPAIGN_BLUEPRINT, { id: this.campaignBlueprintId });
    },
    emailUpdate(email: IEmailBlueprint, update: any, field?: string) {
      const state = this.$store.state as IState;
      const emailId = email.guid;
      const campaignId = state.currentCampaignBlueprintId;
      // nested updated on the step
      if (field) {
        // @ts-ignore
        const existingField = email[field];
        const fieldUpdate = {
          ...existingField,
          ...update,
        };
        this.$store.commit(SET_DUNNING_CAMPAIGN_EMAIL, {
          emailId,
          campaignId,
          data: {
            ...email,
            [field]: fieldUpdate,
            saveState: SAVE_STATE.UNSAVED,
          },
        });
      } else {
        this.$store.commit(SET_DUNNING_CAMPAIGN_EMAIL, {
          emailId,
          campaignId,
          data: {
            ...email,
            ...update,
            saveState: SAVE_STATE.UNSAVED,
          },
        });
      }
      this.scheduleSave();
    },
    cloneBaseEmail(): IEmailBlueprint {
      const base = this.baseEmailBlueprint;
      console.log('BASE', base);
      return {
        ...base,
        deleted: false,
        enabled: true,
      };
    },
    addEmail(): void {
      const state = this.$store.state as IState;
      let newEmail;
      if (this.hasEmails) {
        const allEmails = this.allEmails;
        const lastEmail = allEmails[allEmails.length - 1] as IEmailBlueprint;
        newEmail = generateEmailBlueprint({
          ...lastEmail,
          sendOnDay: lastEmail.sendOnDay + 1,
        });
      } else {
        newEmail = this.cloneBaseEmail();
      }
      newEmail.saveState = SAVE_STATE.UNSAVED;
      const newEmailSequence = this.currentCampaignEmailBlueprints.concat(newEmail);
      this.$store.commit(STORE_DUNNING_CAMPAIGN_BLUEPRINT_DATA, {
        id: state.currentCampaignBlueprintId,
        data: {
          emails: newEmailSequence,
          saveState: SAVE_STATE.UNSAVED,
        },
      });
      this.$store.commit(SET_CURRENT_DUNNING_EMAIL_BLUEPRINT_ID, newEmail.guid);
      this.scheduleSave();
    },
    async markForDelete(id: string) {
      const state = this.$store.state as IState;
      const email = this.currentCampaignEmailBlueprintMap[id];
      this.emailUpdate(email, { delete: true });
      if (state.currentEmailBlueprintId === id) {
        const remainingEmails = this.currentCampaignEmailBlueprints.filter((d: IEmailBlueprint) => !d.delete);
        const newSelection = remainingEmails.length > 0 ? remainingEmails[0].guid : '';
        this.$store.commit(SET_CURRENT_DUNNING_EMAIL_BLUEPRINT_ID, newSelection);
      }
      this.scheduleSave();
    },
  },
});
